export default "__VITE_ASSET__0d0e42d4__"